module.exports = __webpack_public_path__ + "img/0f06831.png";